import styled, { css } from 'styled-components'

import { color, contentStyles } from 'styles/global'

export const PlayerDetailsContainer = styled.div<{ small?: boolean }>`
  display: flex;
  /* position: relative;
  z-index: 10; */
  & > * {
    align-items: center;
    color: ${color('interactiveSecondary')};
    display: flex;
    margin: 0 auto;
  }
  button {
    color: ${color('interactiveSecondary')};
    flex-direction: column;
    justify-content: center;
    text-transform: capitalize;
  }

  ${({ small }) =>
    small &&
    css`
      display: none;
      flex: 1;
      justify-content: space-evenly;
      min-width: 210px;
      & > * {
        margin: 0;
      }
      @media only screen and (min-width: 650px) {
        display: flex;
      }
    `};
`

export const PageContent = styled.div`
  ${contentStyles}
  &.zh {
    p {
      text-indent: 2em;
    }
  }
`
